export default __webpack_public_path__ + "static/media/offer-3.1ac329f7.jpg";